import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import NewResidenceModal from "./NewResidenceModal";
import { residences } from "../services/soar";
import SearchBox from "../common/SearchBox";

function ResidenceFosterHomes(props) {
  const [residenceData, setResidenceData] = useState([]);
  const [newResidence, setNewResidence] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showInactive, setShowInactive] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const body = {
      command: "query",
      application:
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
          : "58990f83-8566-4ba8-b4b5-584a64e4cba1",
      keyword: "bytype",
      searchTerms: {
        type: "FosterHome",
      },
    };
    residenceAction(body);
  }, []);

  const residenceAction = async (body) => {
    const data = await residences(body);
    setResidenceData(data.data);
  };

  const addResidence = () => {
    setNewResidence({
      name: "",
      type: "FosterHome",
      address: "",
      city: "",
      state: "",
      zip: "",
      unit: "",
      doorCode: "",
      leaseStatus: "",
      placementStatus: "",
      programUnit: "",
      programUnitName: "",
      externalIdentifier: "",

      company: "",
      companyName: "",
    });

    setShowModal(true);
  };

  const handleSaveNewResidence = async (data) => {
    const body = {
      command: "insert",
      application:
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
          : "58990f83-8566-4ba8-b4b5-584a64e4cba1",
      name: data.name !== "" ? data.name : data.externalIdentifier,
      type: "FosterHome",
      address: data.address,
      city: data.city,
      state: data.state,
      zip: data.zip,
      unit: data.unit,
      doorCode: data.doorCode,
      externalIdentifier: data.externalIdentifier,
      leaseStatus: data.leaseStatus,
      placementStatus: data.placementStatus,
      programUnit: data.programUnit,
      programUnitName: data.programUnitName,
      company: data.company,
      companyName: data.companyName,
    };

    return await residences(body);
  };

  const bintiAddress = (home) => {
    const bintiHome = home?.binti[0]?.addresses.find(
      (address) => address?.type === "Home"
    )
      ? home?.binti[0]?.addresses.find((address) => address.type === "Home")
      : home?.binti[0]?.addresses[0];
    return bintiHome
      ? `${bintiHome.streetaddress}, ${bintiHome.city}, ${bintiHome.state}`
      : "";
  };

  return (
    <div>
      <>
        <NewResidenceModal
          data={newResidence}
          setData={setNewResidence}
          show={showModal}
          handleSave={handleSaveNewResidence}
          onHide={(response) => {
            setShowModal(false);
            if (response?.message === "Residence created successfully. ") {
              navigate(`/residence/fosterhomes/${response.id}`);
            }
          }}
        />
        <div className="w-100">
          <h1>Foster Homes</h1>
          <div className="row my-4">
            <div className="col-6 mt-2">
              <SearchBox
                placeholder="Search by Name, Address, or City"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <div className="col-4 mt-4">
              {/* <Checkbox
                name="showInactive"
                label="Show Inactive"
                type="checkbox"
                checked={showInactive}
                onChange={() => setShowInactive(!showInactive)}
                className="border border-dark"
              /> */}
            </div>
            <div className="col-2">
              <button
                className="btn btn-primary float-end"
                onClick={() => addResidence()}
              >
                Add Foster Home
              </button>
            </div>
          </div>
          {/* {apartmentComplexes.map((complex, index) => (
        <div key={`complex-${index}`} className="my-4">
          <div className="h3 text-primary">{complex}</div>
          <div className="w-100"> */}
          <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-2">
            {residenceData
              ?.filter((a) => showInactive || a.active)
              .filter(
                (a) =>
                  a.address.toLowerCase().includes(searchQuery.toLowerCase()) ||
                  a.binti[0]?.["application-home-name"]
                    ?.toLowerCase()
                    .includes(searchQuery.toLowerCase()) ||
                  a.binti[0]?.addresses[0]?.streetaddress
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase()) ||
                  a.binti[0]?.addresses[0]?.city
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase()) ||
                  a.city.toLowerCase().includes(searchQuery.toLowerCase()) ||
                  a.programUnitName
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase())
              )
              .map((home, rindex) => (
                <div key={`residence-${rindex}`} className="col mb-2">
                  <div
                    key={home.id}
                    className={`rounded border ${
                      home.active ? "border-dark" : "border-danger border-2"
                    } card-safy bg-light h-100`}
                  >
                    <div className="card-header bg-safy1-1 text-white py-1">
                      <div className="row px-2">
                        <div className="col-11">
                          {home?.binti[0]?.["application-home-name"]}
                        </div>
                        <div className="col-1">
                          <i
                            className="fas fa-pen"
                            onClick={() =>
                              navigate(`/residence/fosterhomes/${home.id}`)
                            }
                          />
                        </div>
                      </div>
                      <div className="px-2 text-white">
                        {home.name !== home.externalIdentifier &&
                          home.externalIdentifier}
                      </div>
                    </div>
                    <div className="card-body p-2 ">
                      <div className="row pb-4">
                        <div className="col">
                          {" "}
                          <i
                            className="fas fa-map-pin text-danger me-2"
                            onClick={() =>
                              window.open(
                                `https://maps.google.com/?q=${bintiAddress(
                                  home
                                )}`
                              )
                            }
                          />
                          {bintiAddress(home)}
                        </div>
                      </div>
                      {home.beds.map((b) => (
                        <div key={b.id} className="row mb-1">
                          <div className="col">{`${b.name}`}</div>
                          <div className="col fw-bold">
                            {b.clientHistory?.find(
                              (h) =>
                                h.admission &&
                                (!h.discharge || h.discharge === "")
                            ) ? (
                              b.clientHistory?.find(
                                (h) =>
                                  h.admission &&
                                  (!h.discharge || h.discharge === "")
                              ).clientName
                            ) : (
                              <div className="rounded border border-dark bg-success text-white px-2">
                                Open
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </>
    </div>
  );
}

export default ResidenceFosterHomes;
